"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AddSubjectsToReviewCycleResponse () {
        return AddSubjectsToReviewCycleResponse;
    },
    get BulkUpdateReviewCycleReportsResponse () {
        return BulkUpdateReviewCycleReportsResponse;
    },
    get BulkUpdateReviewCycleReportsWarning () {
        return BulkUpdateReviewCycleReportsWarning;
    },
    get BulkUpdateReviewCycleReportsWarningCode () {
        return BulkUpdateReviewCycleReportsWarningCode;
    },
    get CreateReviewCycleResponse () {
        return CreateReviewCycleResponse;
    },
    get GetReviewCycleEasyAddFormConfigsResponse () {
        return GetReviewCycleEasyAddFormConfigsResponse;
    },
    get GetReviewCycleFormsSummaryResponse () {
        return GetReviewCycleFormsSummaryResponse;
    },
    get GetReviewCyclePreviewSubjectsResultsResponse () {
        return GetReviewCyclePreviewSubjectsResultsResponse;
    },
    get GetReviewCyclesResponse () {
        return GetReviewCyclesResponse;
    },
    get PostReviewCyclePreviewSubjectsResponse () {
        return PostReviewCyclePreviewSubjectsResponse;
    },
    get ReviewCycleEasyAddFormConfig () {
        return ReviewCycleEasyAddFormConfig;
    },
    get ReviewCycleFormSummary () {
        return ReviewCycleFormSummary;
    },
    get ReviewCycleFormType () {
        return ReviewCycleFormType;
    },
    get ReviewCyclePreviewSubject () {
        return ReviewCyclePreviewSubject;
    },
    get UpdateReviewCycleResponse () {
        return UpdateReviewCycleResponse;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _formassignment = require("../form-assignment");
const _reviewcycle = require("./review-cycle");
const GetReviewCyclesResponse = _zod.z.object({
    data: _zod.z.array(_reviewcycle.ReviewCycle),
    meta: _zod.z.object({
        success: _zod.z.literal(true),
        pagination: _zod.z.object({
            skip: _zod.z.number(),
            limit: _zod.z.number(),
            total: _zod.z.number()
        })
    })
});
const UpdateReviewCycleResponse = _zod.z.object({
    data: _zod.z.object({
        cycleId: _utilsisomorphic.transformObjectId,
        taskId: _utilsisomorphic.transformObjectId.optional()
    }),
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
const CreateReviewCycleResponse = _zod.z.object({
    data: _zod.z.object({
        cycleId: _utilsisomorphic.transformObjectId,
        taskId: _utilsisomorphic.transformObjectId
    }),
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
const AddSubjectsToReviewCycleResponse = _zod.z.object({
    data: _zod.z.object({
        cycleId: _utilsisomorphic.transformObjectId,
        taskId: _utilsisomorphic.transformObjectId
    }),
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
const PostReviewCyclePreviewSubjectsResponse = _zod.z.object({
    data: _zod.z.object({
        previewId: _utilsisomorphic.transformObjectId,
        total: _zod.z.number()
    }),
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
const ReviewCyclePreviewSubject = _zod.z.object({
    userId: _utilsisomorphic.transformObjectId,
    name: _zod.z.string(),
    managerId: _utilsisomorphic.transformObjectId.optional(),
    managerName: _zod.z.string().optional(),
    groupName: _zod.z.string().optional(),
    hireDate: _utilsisomorphic.transformDate.optional()
});
const GetReviewCyclePreviewSubjectsResultsResponse = _zod.z.object({
    data: _zod.z.array(ReviewCyclePreviewSubject),
    meta: _zod.z.object({
        success: _zod.z.literal(true),
        pagination: _zod.z.object({
            skip: _zod.z.number(),
            limit: _zod.z.number(),
            total: _zod.z.number()
        })
    })
});
const ReviewCycleFormType = _zod.z.enum([
    "standard",
    "external",
    "easy-add"
]);
const ReviewCycleFormSummary = _zod.z.object({
    name: _zod.z.string(),
    formType: ReviewCycleFormType
});
const GetReviewCycleFormsSummaryResponse = _zod.z.object({
    data: _zod.z.array(ReviewCycleFormSummary),
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
const ReviewCycleEasyAddFormConfig = _formassignment.EasyAddFormConfig.omit({
    easyAdd: true,
    signers: true
}).extend({
    easyAddFormConfigId: _utilsisomorphic.transformObjectId,
    formName: _zod.z.string(),
    signers: _zod.z.array(_formassignment.NamedSigner)
});
const GetReviewCycleEasyAddFormConfigsResponse = _zod.z.object({
    data: _zod.z.array(ReviewCycleEasyAddFormConfig),
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
const BulkUpdateReviewCycleReportsWarningCode = _zod.z.enum([
    // Unknown id, deleted report, or a report outside this cycle or company
    "report_not_found",
    "external_report_due_dates_skipped",
    "due_dates_before_start_date_skipped",
    // Signers-only update where the new date is before the report's existing authors due date
    "signers_due_date_before_authors_due_date_skipped"
]);
const BulkUpdateReviewCycleReportsWarning = _zod.z.object({
    reviewReportId: _utilsisomorphic.transformObjectId,
    code: BulkUpdateReviewCycleReportsWarningCode,
    message: _zod.z.string()
});
const BulkUpdateReviewCycleReportsResponse = _zod.z.object({
    data: _zod.z.object({
        updatedReportIds: _zod.z.array(_utilsisomorphic.transformObjectId),
        warnings: _zod.z.array(BulkUpdateReviewCycleReportsWarning)
    }),
    meta: _zod.z.object({
        success: _zod.z.literal(true)
    })
});
